import { useParams, Link } from "react-router-dom";
import "../styles/product.css";
import React from "react";


import { sampleProducts } from "../data/productsfamily";

const ProductTypePage = () => {
  const { category, type } = useParams();
  const products = sampleProducts[category]?.filter((product) => product.type === type) || [];

  return (
    <div className="products-container">
      <h1 className="heading">{type.toUpperCase()}</h1>
      <div className="products-grid centered-grid">
        {products.length > 0 ? (
          products.map((product, index) => (
            <div key={index} className="product-card enhanced-card">
              <Link to={`/produto/${product.name}`}>
                <img
                  src={product.image}
                  alt={product.name}
                  className="product-image clickable"
                />
              </Link>
              <h5 className="product-name">{product.name}</h5>
            </div>
          ))
        ) : (
          <p className="no-products">Nenhum produto encontrado para este tipo.</p>
        )}
      </div>
    </div>
  );
};

export default ProductTypePage;
